import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/dashboard`;

export default {
  index() {
    return Client.get(`${resource}`);
  },
  comingConversation(query) {
    return Client.get(`${resource}/coming-conversation`, {
      params: query,
    });
  },
  comingCall(query) {
    return Client.get(`${resource}/coming-call`, {
      params: query,
    });
  },
};
